import { $emit as d } from "../utils/gogocodeTransfer.js";
import { ElInput as m } from "element-plus";
import { checkPwdLevel as w } from "./utils.js";
import { resolveComponent as c, openBlock as u, createBlock as v, withCtx as f, createElementVNode as l, createElementBlock as h, normalizeClass as i, createCommentVNode as V } from "vue";
import { _ } from "../_plugin-vue_export-helper-dad06003.js";
const k = {
  name: "rPassword",
  components: { Input: m },
  props: {
    /**
     * 值
     */
    value: {
      type: String,
      default: ""
    },
    /**
     * 懂得都懂
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * 是否校验密码强度
     */
    checkPwdLevel: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      innerValue: this.value,
      showPassword: !1,
      pwdLevel: 0
    };
  },
  watch: {
    value(e, s) {
      this.innerValue = e;
    }
  },
  methods: {
    handleInput(e) {
      this.pwdLevel = w(e), d(this, "update:value", e);
    }
  },
  emits: [
    {
      /**
       * 输入值改变
       */
      input: (e) => e
    },
    "focus",
    "blur",
    "update:value"
  ]
}, P = /* @__PURE__ */ l(
  "i",
  null,
  null,
  -1
  /* HOISTED */
), g = /* @__PURE__ */ l(
  "i",
  null,
  null,
  -1
  /* HOISTED */
), b = /* @__PURE__ */ l(
  "i",
  null,
  null,
  -1
  /* HOISTED */
), I = [
  P,
  g,
  b
];
function L(e, s, r, C, o, p) {
  const a = c("Input");
  return u(), v(a, {
    type: o.showPassword ? "text" : "password",
    class: "r-password",
    modelValue: o.innerValue,
    "onUpdate:modelValue": s[1] || (s[1] = (n) => o.innerValue = n),
    placeholder: r.placeholder,
    onInput: p.handleInput,
    onFocus: s[2] || (s[2] = (n) => e.$emit("focus")),
    onBlur: s[3] || (s[3] = (n) => e.$emit("blur")),
    autocomplete: "new-password"
  }, {
    suffix: f(() => [
      l("div", null, [
        r.checkPwdLevel && o.innerValue.length > 0 ? (u(), h(
          "span",
          {
            key: 0,
            class: i([
              "r-password-CheckLevel",
              `r-password-CheckLevel--${o.pwdLevel}`
            ])
          },
          I,
          2
          /* CLASS */
        )) : V("v-if", !0),
        l(
          "i",
          {
            class: i(["r-password-VisibleToggle", {
              "r-password-VisibleToggle--visible": !o.showPassword,
              "r-password-VisibleToggle--invisible": o.showPassword
            }]),
            onClick: s[0] || (s[0] = (n) => o.showPassword = !o.showPassword)
          },
          null,
          2
          /* CLASS */
        )
      ])
    ]),
    _: 1
    /* STABLE */
  }, 8, ["type", "modelValue", "placeholder", "onInput"]);
}
const t = /* @__PURE__ */ _(k, [["render", L], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/password/password.vue"]]);
t.install = function(e) {
  e.component(t.name, t);
};
export {
  t as default
};
